import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=10d00d0b&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=10d00d0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d00d0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d00d0b')) {
      api.createRecord('10d00d0b', component.options)
    } else {
      api.reload('10d00d0b', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=10d00d0b&scoped=true&", function () {
      api.rerender('10d00d0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27N4qPRNYJIHo/JS/comp/PopupBox.vue"
export default component.exports